export const VersionNumber = "1.2025.4.1002";



// WEBPACK FOOTER //
// ./src/components/common/versionnumber.js